import { ReactComponent as RenewPaymentSVG } from "./renew-payment.svg";
import { SvgIcon } from '@mui/material';

export default function IconRenewPayment(props) {
  return <SvgIcon {...props} component={RenewPaymentSVG} viewBox="0 0 25 24" />;
}